import * as React from "react";

type Variant = "primary" | "outline" | "ghost" | "danger";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const styles: Record<Variant, React.CSSProperties> = {
  primary: {
    background: "var(--primary)",
    color: "#fff",
    boxShadow: "0 4px 12px rgba(90,58,181,.25)",
    border: "none",
  },
  outline: {
    background: "transparent",
    color: "var(--ink)",
    border: "1.5px solid var(--n100)",
  },
  ghost: {
    background: "transparent",
    color: "var(--n600)",
    border: "none",
  },
  danger: {
    background: "transparent",
    color: "var(--danger)",
    border: "1.5px solid var(--danger)",
  },
};

export const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  style,
  children,
  ...rest
}) => (
  <button
    style={{
      height: 38,
      padding: "0 18px",
      borderRadius: 10,
      fontSize: 13,
      fontWeight: 600,
      cursor: "pointer",
      fontFamily: "inherit",
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      transition: "all 150ms cubic-bezier(.22,1,.36,1)",
      ...styles[variant],
      ...style,
    }}
    {...rest}
  >
    {children}
  </button>
);
